// Function component
const Logo: React.FC = () => (
	<svg width='150' height='26' viewBox='0 0 150 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g clipPath='url(#clip0_1_95)'>
			<path
				d='M83.7346 4.47522V6.9979H78.5631V11.5965H82.3832V14.0929H78.5631V19.5062H83.7346V22.0026H75.8864V4.47522H83.7346Z'
				fill='#7AA9CC'
			/>
			<path
				d='M91.558 12.8579L95.6121 22.0026H92.6235L89.9988 15.6433L87.53 22.0026H84.5934L88.4655 12.8579L84.7493 4.47522H87.7119L90.0248 10.0987L92.1817 4.47522H95.0923L91.558 12.8579Z'
				fill='#7AA9CC'
			/>
			<path
				d='M99.9443 14.9075V22.0026H97.2676V4.47522H101.711C103.375 4.47522 104.596 4.86939 105.35 5.60517C106.259 6.49862 106.727 7.86507 106.727 9.70452C106.727 11.5177 106.259 12.8841 105.35 13.7776C104.96 14.1718 104.466 14.4608 103.894 14.6448C103.323 14.8287 102.595 14.9075 101.711 14.9075H99.9443ZM99.9443 12.4111H101.114C102.101 12.4111 102.803 12.2535 103.193 11.9381C103.713 11.544 103.972 10.8082 103.972 9.70452C103.972 8.60085 103.713 7.83879 103.193 7.4709C102.803 7.15557 102.101 6.9979 101.114 6.9979H99.9443V12.4111Z'
				fill='#7AA9CC'
			/>
			<path
				d='M111.238 14.8287V22.0026H108.561V4.47522H112.771C114.252 4.47522 115.396 4.84311 116.201 5.55261C117.215 6.44606 117.735 7.75996 117.735 9.4943C117.735 11.7279 116.955 13.252 115.396 14.0667L117.969 22.0026H115.136L112.849 14.8287H111.238ZM111.238 12.306H112.225C112.953 12.306 113.473 12.2535 113.785 12.1221C114.59 11.7805 114.98 10.9396 114.98 9.65196C114.98 8.67968 114.746 7.99646 114.304 7.54973C114.07 7.28695 113.759 7.12929 113.395 7.07673C113.057 7.02417 112.667 6.9979 112.225 6.9979H111.238V12.306Z'
				fill='#7AA9CC'
			/>
			<path
				d='M127.817 4.47522V6.9979H122.645V11.5965H126.465V14.0929H122.645V19.5062H127.817V22.0026H119.969V4.47522H127.817Z'
				fill='#7AA9CC'
			/>
			<path
				d='M138.759 8.60084L136.186 9.38918C135.77 7.62856 135.017 6.76139 133.873 6.76139C133.405 6.76139 132.99 6.94533 132.678 7.26067C132.314 7.60228 132.132 8.02272 132.132 8.54828C132.132 9.20523 132.392 9.78334 132.86 10.3089C133.172 10.6505 133.951 11.3075 135.173 12.2272C136.42 13.2257 137.278 13.9878 137.745 14.5922C138.499 15.5119 138.863 16.563 138.863 17.7981C138.863 19.0857 138.447 20.1631 137.589 20.9777C136.706 21.8449 135.562 22.2653 134.133 22.2653C131.171 22.2653 129.403 20.6098 128.858 17.3251L131.43 16.563C131.768 18.6653 132.678 19.7164 134.133 19.7164C134.731 19.7164 135.225 19.5324 135.562 19.1646C135.926 18.7967 136.108 18.2974 136.108 17.7193C136.108 17.0886 135.874 16.5368 135.432 16.0112C135.069 15.5908 134.419 15.0126 133.535 14.3031C132.236 13.2783 131.43 12.6476 131.171 12.3849C129.975 11.2024 129.377 9.94101 129.377 8.54828C129.377 7.15555 129.871 6.07816 130.833 5.26355C131.664 4.58032 132.678 4.23871 133.899 4.23871C136.394 4.23871 138.005 5.68399 138.759 8.60084Z'
				fill='#7AA9CC'
			/>
			<path
				d='M149.836 8.60084L147.264 9.38918C146.848 7.62856 146.094 6.76139 144.951 6.76139C144.483 6.76139 144.067 6.94533 143.755 7.26067C143.392 7.60228 143.21 8.02272 143.21 8.54828C143.21 9.20523 143.469 9.78334 143.937 10.3089C144.249 10.6505 145.029 11.3075 146.25 12.2272C147.498 13.2257 148.355 13.9878 148.823 14.5922C149.577 15.5119 149.94 16.563 149.94 17.7981C149.94 19.0857 149.525 20.1631 148.667 20.9777C147.783 21.8449 146.64 22.2653 145.211 22.2653C142.248 22.2653 140.481 20.6098 139.935 17.3251L142.508 16.563C142.846 18.6653 143.755 19.7164 145.211 19.7164C145.808 19.7164 146.302 19.5324 146.64 19.1646C147.004 18.7967 147.186 18.2974 147.186 17.7193C147.186 17.0886 146.952 16.5368 146.51 16.0112C146.146 15.5908 145.497 15.0126 144.613 14.3031C143.314 13.2783 142.508 12.6476 142.248 12.3849C141.053 11.2024 140.455 9.94101 140.455 8.54828C140.455 7.15555 140.949 6.07816 141.91 5.26355C142.742 4.58032 143.755 4.23871 144.977 4.23871C147.472 4.23871 149.083 5.68399 149.836 8.60084Z'
				fill='#7AA9CC'
			/>
			<path
				d='M43.376 14.3032H39.5819V22.0026H36.9052V4.47522H39.5819V11.7805H43.376V4.47522H46.0787V22.0026H43.376V14.3032Z'
				fill='#1C6296'
			/>
			<path
				d='M57.9836 10.0461V16.4317C57.9836 17.4302 57.9056 18.2185 57.7497 18.8755C57.5938 19.5062 57.3339 20.0843 56.9961 20.5836C56.1905 21.6872 54.9431 22.2653 53.2539 22.2653C51.5647 22.2653 50.3173 21.6872 49.5117 20.5836C49.0959 19.9792 48.81 19.3222 48.6801 18.5864C48.5761 17.9295 48.5242 17.1937 48.5242 16.4317V10.0461C48.5242 9.07384 48.6021 8.25923 48.7581 7.62856C48.914 6.97161 49.1479 6.41977 49.5117 5.92049C50.3173 4.79054 51.5647 4.23871 53.2539 4.23871C54.9431 4.23871 56.1905 4.79054 56.9961 5.92049C57.4119 6.49861 57.6977 7.18183 57.8017 7.91761C57.9316 8.57456 57.9836 9.28406 57.9836 10.0461ZM51.2009 10.0987V16.3791C51.2009 17.22 51.2529 17.7981 51.3048 18.1134C51.5647 19.1908 52.2144 19.7164 53.2539 19.7164C54.0595 19.7164 54.6312 19.4011 54.9431 18.7704C55.125 18.4288 55.2289 18.0609 55.2549 17.6404C55.2809 17.2988 55.2809 16.8784 55.2809 16.3791V10.0987C55.2809 9.25779 55.2549 8.67967 55.177 8.36434C54.9431 7.31322 54.2934 6.76139 53.2539 6.76139C52.4483 6.76139 51.8766 7.07672 51.5647 7.73367C51.3828 8.07528 51.2788 8.44317 51.2529 8.83734C51.2269 9.17895 51.2009 9.5994 51.2009 10.0987Z'
				fill='#1C6296'
			/>
			<path
				d='M66.6716 18.1923H62.9814L62.2797 22.0026H59.655L62.9814 4.47522H66.6456L70.1539 22.0026H67.3992L66.6716 18.1923ZM66.2038 15.6959L64.8005 7.83879L63.3972 15.6959H66.2038Z'
				fill='#1C6296'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.2056 15.8484C20.2056 15.4509 19.8865 15.1282 19.4933 15.1282H19.493C19.0998 15.1282 18.7806 15.4509 18.7806 15.8484V22.3544C18.7806 22.7519 19.0998 23.0747 19.493 23.0747H19.4933C19.8865 23.0747 20.2056 22.7519 20.2056 22.3544V15.8484Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.2056 15.8495C20.2056 15.4514 19.8859 15.1282 19.4921 15.1282H14.6819C14.2882 15.1282 13.9684 15.4514 13.9684 15.8495C13.9684 16.2476 14.2882 16.5708 14.6819 16.5708H19.4921C19.8859 16.5708 20.2056 16.2476 20.2056 15.8495Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.3934 15.8484C15.3934 15.4509 15.0743 15.1282 14.6811 15.1282H14.6809C14.2876 15.1282 13.9684 15.4509 13.9684 15.8484V22.3544C13.9684 22.7519 14.2876 23.0747 14.6809 23.0747H14.6811C15.0743 23.0747 15.3934 22.7519 15.3934 22.3544V15.8484Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M26.7234 6.22054C26.7234 5.5153 26.157 4.94275 25.4594 4.94275H25.4592C24.7617 4.94275 24.1953 5.5153 24.1953 6.22054V22.7115C24.1953 23.4168 24.7617 23.9893 25.4592 23.9893H25.4594C26.157 23.9893 26.7234 23.4168 26.7234 22.7115V6.22054Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.88543 6.22054C9.88543 5.5153 9.31908 4.94275 8.62144 4.94275H8.62136C7.92373 4.94275 7.35736 5.5153 7.35736 6.22054V22.7115C7.35736 23.4168 7.92373 23.9893 8.62136 23.9893H8.62144C9.31908 23.9893 9.88543 23.4168 9.88543 22.7115V6.22054Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.9771 0.663589C16.3261 0.0514917 17.0991 -0.158229 17.7037 0.195169L29.0221 6.8118C29.6266 7.16519 29.8337 7.94785 29.4847 8.56002C29.1357 9.17211 28.3627 9.38183 27.7581 9.02841L16.4397 2.41178C15.8352 2.05838 15.6281 1.27569 15.9771 0.663589Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18.1034 0.663589C17.7544 0.0514917 16.9814 -0.158229 16.3768 0.195169L5.05845 6.8118C4.45391 7.16519 4.24679 7.94785 4.59582 8.56002C4.94484 9.17211 5.71783 9.38183 6.32235 9.02841L17.6408 2.41178C18.2453 2.05838 18.4524 1.27569 18.1034 0.663589Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.462968 24.8748C11.4077 21.4002 23.1405 21.4002 34.0853 24.8748C34.4018 24.9691 34.5778 25.291 34.4714 25.5945C34.4689 25.6036 34.466 25.6124 34.463 25.6212C34.46 25.63 34.4568 25.6387 34.4534 25.6472C34.4465 25.6642 34.4388 25.6806 34.4304 25.6964C34.4134 25.7281 34.3934 25.7575 34.3707 25.7842C34.3252 25.8377 34.2689 25.8811 34.2048 25.9131C34.0767 25.9769 33.9176 25.9949 33.7507 25.9563C23.0238 22.5509 11.5245 22.5509 0.797619 25.9563C0.510332 26.0177 0.179115 25.8776 0.0768795 25.5945C-0.0141754 25.2856 0.1567 24.9657 0.462968 24.8748Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.2056 15.8484C20.2056 15.4509 19.8865 15.1282 19.4933 15.1282H19.493C19.0998 15.1282 18.7806 15.4509 18.7806 15.8484V22.3544C18.7806 22.7519 19.0998 23.0747 19.493 23.0747H19.4933C19.8865 23.0747 20.2056 22.7519 20.2056 22.3544V15.8484Z'
				fill='#67D91D'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.2056 15.8495C20.2056 15.4514 19.8859 15.1282 19.4921 15.1282H14.6819C14.2882 15.1282 13.9684 15.4514 13.9684 15.8495C13.9684 16.2476 14.2882 16.5708 14.6819 16.5708H19.4921C19.8859 16.5708 20.2056 16.2476 20.2056 15.8495Z'
				fill='#59BB19'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.3934 15.8484C15.3934 15.4509 15.0743 15.1282 14.6811 15.1282H14.6809C14.2876 15.1282 13.9684 15.4509 13.9684 15.8484V22.3544C13.9684 22.7519 14.2876 23.0747 14.6809 23.0747H14.6811C15.0743 23.0747 15.3934 22.7519 15.3934 22.3544V15.8484Z'
				fill='#479515'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M26.7234 6.22054C26.7234 5.5153 26.157 4.94275 25.4594 4.94275H25.4592C24.7617 4.94275 24.1953 5.5153 24.1953 6.22054V22.7115C24.1953 23.4168 24.7617 23.9893 25.4592 23.9893H25.4594C26.157 23.9893 26.7234 23.4168 26.7234 22.7115V6.22054Z'
				fill='#68D91E'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.88543 6.22054C9.88543 5.5153 9.31908 4.94275 8.62144 4.94275H8.62136C7.92373 4.94275 7.35736 5.5153 7.35736 6.22054V22.7115C7.35736 23.4168 7.92373 23.9893 8.62136 23.9893H8.62144C9.31908 23.9893 9.88543 23.4168 9.88543 22.7115V6.22054Z'
				fill='#3A7910'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.9771 0.663589C16.3261 0.0514917 17.0991 -0.158229 17.7037 0.195169L29.0221 6.8118C29.6266 7.16519 29.8337 7.94785 29.4847 8.56002C29.1357 9.17211 28.3627 9.38183 27.7581 9.02841L16.4397 2.41178C15.8352 2.05838 15.6281 1.27569 15.9771 0.663589Z'
				fill='#59BB1A'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18.1034 0.663589C17.7544 0.0514917 16.9814 -0.158229 16.3768 0.195169L5.05845 6.8118C4.45391 7.16519 4.24679 7.94785 4.59582 8.56002C4.94484 9.17211 5.71783 9.38183 6.32235 9.02841L17.6408 2.41178C18.2453 2.05838 18.4524 1.27569 18.1034 0.663589Z'
				fill='#489514'
				fillOpacity='0.7'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.462968 24.8748C11.4077 21.4002 23.1405 21.4002 34.0853 24.8748C34.4018 24.9691 34.5778 25.291 34.4714 25.5945C34.4689 25.6036 34.466 25.6124 34.463 25.6212C34.46 25.63 34.4568 25.6387 34.4534 25.6472C34.4465 25.6642 34.4388 25.6806 34.4304 25.6964C34.4134 25.7281 34.3934 25.7575 34.3707 25.7842C34.3252 25.8377 34.2689 25.8811 34.2048 25.9131C34.0767 25.9769 33.9176 25.9949 33.7507 25.9563C23.0238 22.5509 11.5245 22.5509 0.797619 25.9563C0.510332 26.0177 0.179115 25.8776 0.0768795 25.5945C-0.0141754 25.2856 0.1567 24.9657 0.462968 24.8748Z'
				fill='#DCB983'
			/>
		</g>
		<defs>
			<clipPath id='clip0_1_95'>
				<rect width='150' height='26' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

export default Logo;
